"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_redux_1 = require("react-redux");
var history_1 = require("remota-client/util/history");
var app_1 = require("remota-client/app");
var store_1 = require("remota-client/store");
require("remota-client/datadog");
var route_1 = require("./component/route");
var reducer_1 = require("./module/reducer");
var App = (0, app_1.appGen)(route_1.OutsideRoute, history_1.history);
var store = (0, store_1.storeGen)((0, reducer_1.reducerGen)(history_1.history), history_1.history);
react_dom_1.default.render(react_1.default.createElement(react_redux_1.Provider, { store: store },
    react_1.default.createElement(App, null)), document.getElementById("app"));
